import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStaff } from "../../store/slices/staff";
import { addClassteacher } from "../../store/slices/classteacher";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { toast } from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import Select from "react-select";

export default function AddClassTeacher() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { classsectionList = [], loading } = useSelector(
    (state) => state.classsection || {}
  );

  const { staffList = [] } = useSelector((state) => state.staff || {});
  const [formData, setFormData] = useState({
    standardId: "",
    sectionId: "",
    teacherId: "",
  });

  const [errors, setErrors] = useState({});

  /* ---------- API CALL ---------- */
  useEffect(() => {
    dispatch(fetchStandardSection());
    dispatch(getStaff());
  }, [dispatch]);

  // Standards
  const standards = classsectionList.map((item) => item.standardId);

  // Sections based on standard
  const sections =
    classsectionList.find(
      (item) => item.standardId?._id === formData.standardId
    )?.sectionId || [];

  // Teachers
  const teachers = staffList.filter(
    (t) => t.dept === "Teaching" && t.status === 1 && !t.isDeleted
  );

  /* ---------- HANDLER ---------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "standardId" && { sectionId: "", teacherId: "" }),
      ...(name === "sectionId" && { teacherId: "" }),
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  /* ---------- VALIDATION ---------- */
  const validate = () => {
    let newErrors = {};

    if (!formData.standardId) newErrors.standardId = "Please select standard";
    if (!formData.sectionId) newErrors.sectionId = "Please select section";
    if (!formData.teacherId) newErrors.teacherId = "Please select teacher";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {

      return;
    }

    try {
      await dispatch(addClassteacher(formData)).unwrap();
      toast.success("ClassTeacher added successfully ");


      navigate("/institute/classteachers");
    } catch (err) {
      toast.error(err || "Failed to add class teacher ");
    }
  };

  const teacherOptions = teachers.map((teacher) => ({
    value: teacher._id,
    label: teacher.name,
  }));

  return (
    <>

      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />
            <Link to="/institute/classteachers">Class Teacher</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Class Teacher</span>
          </div>


        </div>

      </div>


      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">

            <Col lg={3} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>
                <Form.Select
                  name="standardId"
                  value={formData.standardId}
                  onChange={handleChange}
                >
                  <option value="">Select Standard</option>
                  {standards.map((std) => (
                    <option key={std._id} value={std._id}>
                      {std.name}
                    </option>
                  ))}
                </Form.Select>
                {errors.standardId && (
                  <small className="text-danger">{errors.standardId}</small>
                )}
              </Form.Group>
            </Col>

            {/* SECTION */}
            <Col lg={3} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Section</Form.Label>
                <Form.Select
                  name="sectionId"
                  value={formData.sectionId}
                  onChange={handleChange}
                  disabled={!formData.standardId}
                >
                  <option value="">Select Section</option>
                  {sections.map((sec) => (
                    <option key={sec._id} value={sec._id}>
                      {sec.name}
                    </option>
                  ))}
                </Form.Select>
                {errors.sectionId && (
                  <small className="text-danger">{errors.sectionId}</small>
                )}
              </Form.Group>
            </Col>

            {/* TEACHER */}
            <Col lg={3} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Teacher</Form.Label>
                <Select
                  options={teacherOptions}
                  placeholder="Select Teacher"
                  isSearchable
                  isDisabled={!formData.sectionId}
                  value={
                    teacherOptions.find(
                      (option) => option.value === formData.teacherId
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setFormData((prev) => ({
                      ...prev,
                      teacherId: selectedOption ? selectedOption.value : "",
                    }));

                    setErrors((prev) => ({
                      ...prev,
                      teacherId: "",
                    }));
                  }}
                />
                {errors.teacherId && (
                  <small className="text-danger">{errors.teacherId}</small>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="cta-actions mt-5">
            <button
              type="button"
              className="btn-cancel"
              style={{ color: "black" }}
              onClick={() => navigate("/institute/classteachers")}
            >
              Cancel
            </button>

            <button type="submit" className="btn-submit" disabled={loading}>
              Submit
            </button>
          </div>
        </Form>

      </div>
    </>
  );
}
